import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import DataTable from 'react-data-table-component'
import apiService from 'apiService'
import DisableStoreIcon from 'components/TableIcons/DisableStoreIcon'
import EnableStoreIcon from 'components/TableIcons/EnableStoreIcon'
import DeleteStoreIcon from 'components/TableIcons/DeleteStoreIcon'
import StoreSettingsIcon from 'components/TableIcons/StoreSettingsIcon'

// components

export default function StoresTable() {
    const [stores, setStores] = useState([])
    const [update, setUpdate] = useState(0)
    const [isAdmin, setIsAdmin] = useState(0)

    const columns = [
        {
            name: 'ID',
            selector: row => row.id
        },
        {
            name: 'Όνομα',
            grow: 3,
            selector: row => row.name
        },
        {
            name: 'Κατάσταση',
            selector: row => (row.enabled === 1 ? 'ΕΝΕΡΓΟ' : 'ΑΝΕΝΕΡΓΟ'),
            style: {
                fontWeight: 'bold'
            },
            conditionalCellStyles: [
                {
                    when: row => row.enabled === 1,
                    style: {
                        color: 'green'
                    }
                },
                {
                    when: row => row.enabled !== 1,
                    style: {
                        color: 'red'
                    }
                }
            ]
        },
        {
            name: 'Ενέργειες',
            cell: row => (
                <>
                    <StoreSettingsIcon storeId={row.id} />
                    {row.enabled === 1 ? <DisableStoreIcon storeId={row.id} refreshTable={setUpdate} /> : <EnableStoreIcon storeId={row.id} refreshTable={setUpdate} />}
                    {isAdmin ? <DeleteStoreIcon storeId={row.id} refreshTable={setUpdate} /> : ''}
                </>
            )
        }
    ]

    const getStores = async () => {
        const result = await apiService.get(`/stores`)
        setStores(result)
    }

    useEffect(() => {
        const cookieDataItem = localStorage.getItem(`robot-user-data`)
        if (!cookieDataItem) return
        const userData = JSON.parse(cookieDataItem)
        setIsAdmin(userData.role_id === 2)
        getStores()
    }, [update])

    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
                <div className="rounded-t mb-0 px-4 py-3 border-0">
                    <div className="flex flex-wrap items-center">
                        <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                            <h3 className={'font-semibold text-lg light'}>Πίνακας Καταστημάτων</h3>
                        </div>
                    </div>
                </div>
                <DataTable columns={columns} data={stores} />
            </div>
        </>
    )
}

StoresTable.defaultProps = {
    color: 'light'
}

StoresTable.propTypes = {
    color: PropTypes.oneOf(['light', 'dark'])
}
